import React, { Component } from 'react';
import { Container, Avatar, Paper, Grid, Breadcrumbs, Link, Typography, TextField, Table, TableContainer, Button, TableHead, TableRow, TableBody, TableCell,IconButton} from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsIcon from '@material-ui/icons/Settings'
import { consumerFirebase } from '../../config';
import { Redirect } from 'react-router-dom'



const style = {
  
   root: {
      width: '100%'
   },
   row: {
      color: "#ffffff"
   },
   body: {
      fontSize: 14,
   },
   cardGrid: {
      paddingLeft: "5em"

   },
   homeIcon: {
      width: 20,
      height: 20,
      marginRight: "4px"
   },
   link: {
      display: "flex",
   },
   gridTextField: {
      marginTop: "2em"
   },
   card: {
      height: "100%",
      display: "flex",
      flexDirection:"column"
   },
   cardMedia: {
      paddingTop: "56.25%"
   },
   cardContent: {
      flexGrow: 1
   },
   tablecontainer: {
      margin: "auto"
   },
   paper: {
      marginTop: "2em",
      paddingTop: "1em",
      paddingBottom: "2em",
      alignContent: "center",
      width: "100%"
   },
   avatarRestaurant: {
      width: 100,
      height: 100,
      paddingLeft: '6%',
   }
}

class CategoriesList extends Component {
   

   state = {
      companies: [],
      searchText: "",
      redirect: false
   }

   changeSearchText = e => {
     const self = this;
     self.setState({
        [e.target.name] : e.target.value
     })

     if(self.state.typingTimeout){
        clearTimeout(self.state.typingTimeout);
     }
     self.setState({
        name: e.target.value,
        typing: false,
        typingTimeout: setTimeout(goTime => {
           let objectQuery = this.props.firebase.db
           .collection("Categories")
           .orderBy("name")
           .where("keywords", "array-contains", self.state.searchText.toLowerCase());

           if(self.state.searchText.trim()===""){
              objectQuery = this.props.firebase.db
              .collection("Categories")
              .orderBy("name");
           }

           objectQuery.get().then(snapshot => {
              const arrayProduct = snapshot.docs.map(doc=>{
                 let data = doc.data();
                 let id = doc.id;
                 return {id, ...data};
              })
              this.setState({
                 companies: arrayProduct
              })
           })
        }, 500)
     })
   }

   async componentDidMount(){
      let objectQuery = this.props.firebase.db.collection("Categories").orderBy("name");

      const snapshot = await objectQuery.get();

      const arrayProduct = snapshot.docs.map(doc => {
         let data = doc.data();
         let id = doc.id;
         return { id, ...data};
      })

      this.setState({
         companies: arrayProduct
      })
   }

   dropProduct = id => {
      this.props.firebase.db
      .collection("Categories")
      .doc(id)
      .delete()
      .then(success => {
         this.dropProductToList(id);
      })
   }

   dropProductToList = id => {
      const productListNew = this.state.companies.filter (
         company => company.id!==id
      )
      this.setState({
         companies: productListNew
      })
   }


   editProduct = id => {
      this.props.history.push("categories/" + id);
   }

   subcategory = id => {
      this.props.history.push("categories/" + id + "/subcategories");
   }

   renderRedirect = () => {
      this.props.history.push("categories/new");
   }

   render() {
      return (
         <Container style={style.cardGrid} xs={12} md={8}>
               <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                     <Breadcrumbs aria-label="breadcrumb">
                        <Link color="inherit" style={style.link} href="/profile">
                           <HomeIcon style={style.homeIcon}/>
                        </Link>
                        <Typography color="textPrimary">Categorías</Typography>
                     </Breadcrumbs>
                  </Grid>
                  <Grid item xs={12} sm={4} style={style.gridTextField}>
                     <TextField
                        name="searchText"
                        label="Buscar Categoría"
                        variant="outlined"
                        fullWidth
                        onChange={this.changeSearchText}
                        value={this.state.searchText}
                     />
                  </Grid>
                  
                  
                  <Grid item xs={12} md={12}>
                     <Grid item xs={12} sm={2} style={style.gridTextField}>
                        <Button
                           type="button"
                           variant="contained"
                           size="large"
                           color="primary"
                           style={style.submit}
                           onClick={this.renderRedirect}
                        >
                           Nuevo
                        </Button>
                     </Grid>

                     <Grid container spacing={4}>
                        <Grid item xs={12} md={12}>
                           <Paper style={style.paper} justify="center" elevation={4} xs={12} md={8}>
                              <TableContainer style={style.tablecontainer} justify="center">
                                 <Table style={style.table} justify="center" aria-label="simple table">
                                    <TableHead style={style.head}>
                                       <TableRow style={style.row}>
                                          <TableCell align="center"></TableCell>
                                          <TableCell align="center">Nombre Categoria</TableCell>
                                          <TableCell align="center">Descripción</TableCell>
                                       </TableRow>
                                    </TableHead>
                                    <TableBody>
                                       {this.state.companies.map(info => (
                                          <TableRow key={info.id}>
                                             <TableCell style={style.avatarRestaurant} ></TableCell>
                                             <TableCell align="center">{info.name}</TableCell>
                                             <TableCell align="center">{info.description}</TableCell>
                                             <br></br>
                                             <TableCell align="center">
                                                <IconButton aria-label="edit" onClick={() => this.editProduct(info.id)}>
                                                   <EditIcon />
                                                </IconButton>
                                                <IconButton aria-label="edit" onClick={() => this.subcategory(info.id)}>
                                                   <SettingsIcon />
                                                </IconButton>
                                                <IconButton aria-label="delete" onClick={() => this.dropProduct(info.id)}>
                                                   <DeleteIcon />
                                                </IconButton>
                                             </TableCell>                                             
                                          </TableRow> 
                                       ))}                         
                                    </TableBody>
                                 </Table>
                              </TableContainer>
                           </Paper>
                        </Grid>   
                     </Grid>
                  </Grid>
               </Grid>   
         </Container>
      )
   }
}
export default consumerFirebase(CategoriesList)